<script setup lang="ts">
import { EventListPageType } from '~/composables/types/strapiEventListPage'

definePageMeta({
  contentGroup: 'city',
})
</script>

<template>
  <event-list-page :page-type="EventListPageType.CITY"></event-list-page>
</template>
